import { Quartiles, RIGHT_QUARTILE } from '../config/toothConfig';

export const isRightQuartile = (quartile: Quartiles) =>
  RIGHT_QUARTILE.includes(quartile);
